import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {ConditionGroup, SegmentAccountCountResponse} from "./types";

const countSegmentAccounts = async (conditions: ConditionGroup): Promise<SegmentAccountCountResponse> => {
  const response = await axiosReachInstance.post<
    SegmentAccountCountResponse,
    AxiosResponse<SegmentAccountCountResponse>,
    ConditionGroup
  >("/segments/count", conditions);
  return response.data;
};

export const useCountSegmentAccounts = (
  options?: BaseMutationOptions<SegmentAccountCountResponse, ConditionGroup>
): BaseUseMutationResult<SegmentAccountCountResponse, ConditionGroup> => {
  return useBaseMutation<SegmentAccountCountResponse, ConditionGroup>(countSegmentAccounts, options);
};
